/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SyncRunResponse {
  id: string;
  kind: string;
  trigger: string | null;
  status: string;
  pulled: number;
  pushed: number;
  conflicts: number;
  errors: number;
  started_at: string | null;
  finished_at: string | null;
}
